import React from 'react';
// ui
import { Slider } from 'rmwc/Slider';
// comp
import TimelineMarker from "./TimelineMarker";
//
// export const timelineStart = new Date(1914, 6, 28);
// export const timelineEnd = new Date(1918, 10, 11);
// export const totalDaysOnTimeline = Math.round((timelineEnd - timelineStart) / (1000 * 60 * 60 * 24));

export const startDate = new Date(1914, 6, 28);
export const endDate = new Date(1918, 10, 11);

export const totalDaysOfWar = Math.round((endDate - startDate) / (1000 * 60 * 60 * 24));
export const oneDayAsFraction = 100 / totalDaysOfWar;

const getDatePosition = (date) => {
    const daysFromStart = Math.round((date - startDate) / (1000 * 60 * 60 * 24));
    return daysFromStart * oneDayAsFraction;
};

const year1915 = new Date(1915, 0, 0);
const year1916 = new Date(1916, 0, 0);
const year1917 = new Date(1917, 0, 0);
const year1918 = new Date(1918, 0, 0);


const Timeline = ({ plaqueData, currentDayOfWar, onCurrentDaySelect, isPlaying, showSlider }) => {
    let currentDate = new Date(startDate);
    currentDate.setDate(startDate.getDate() + currentDayOfWar);

    const keyDateMarkers = [
        {
            date: year1915,
            position: getDatePosition(year1915),
            label: '1915'
        },
        {
            date: year1916,
            position: getDatePosition(year1916),
            label: '1916'
        },
        {
            date: year1917,
            position: getDatePosition(year1917),
            label: '1917'
        },
        {
            date: year1918,
            position: getDatePosition(year1918),
            label: '1918'
        }
    ];

    return (
        <div style={{ margin:'10px 10px', position:'relative' }}>

            {showSlider &&
            <Slider
                style={{position:'absolute'}}
                value={currentDayOfWar / totalDaysOfWar}
                min={0}
                max={1}
                step={0.001}
                onInput={evt => onCurrentDaySelect(Math.round(evt.detail.value * totalDaysOfWar))}
            />
            }

            <svg width={'100%'} height={50}>
                <line x1={1} y1={25} x2={`${100}%`} y2={25} stroke={'rgb(0,0,0)'}
                      strokeLinecap={'round'}/>
                {
                    keyDateMarkers.map((marker) => {
                        return (
                            <g key={marker.label}>
                                <line x1={`${marker.position}%`} y1={25}
                                      x2={`${marker.position}%`} y2={32}
                                      stroke={'rgb(0,0,0)'} strokeLinecap={'round'}/>
                                <text x={`${marker.position}%`} y="50"
                                      textAnchor={'middle'}
                                      style={{ font: 'italic 13px sans-serif' }}>{marker.label}</text>
                            </g>
                        )
                    })
                }

                {
                    plaqueData.map(soldier => {
                        const { dateKilledPosition, daysIntoWar } = soldier;

                        return (
                            <TimelineMarker key={soldier.uid}
                                            isPlaying={isPlaying}
                                            dateTriggered={(currentDayOfWar >= daysIntoWar) || !showSlider}
                                            dateKilledPosition={dateKilledPosition}/>)
                    })
                }

            </svg>
        </div>
    )
};

export default Timeline;


export const TO_DATE_TEXT = (dateNumber) => {
    const d = new Date(dateNumber);
    const date = d.getDate();
    const dateTwoDigits = date > 9 ? date : '0' + date;

    const monthIndex = d.getMonth();
    const month = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'][monthIndex];
    const year = d.getFullYear();

    return `${dateTwoDigits} ${month} ${year}`;
}


// WEBPACK FOOTER //
// ./src/app/components/Timeline.js